import type {RouteRecordRaw} from 'vue-router';

export const usersRoutes: RouteRecordRaw[] = [
  {
    name: 'users',
    path: '/users',
    component: () => import('@/views/Empty.vue'),
    meta: {
      feature: 'page.users',
      permissions: ['insertUser', 'deleteUser', 'manageUsers'],
      title: (t) => t('account.index.user', 2),
    },
  },
];
